module.exports = __webpack_public_path__ + "static/futura-f9f02ed05aa86534c3842d44cb20d6c4.ttf";